import { StoreAction, XmAction } from 'store/actions';
import { AdditionalDevicePayment, AdditionalDevicePaymentResult } from './models';

export function additionalDevicePaymentReducer(state: AdditionalDevicePayment[] = [], action: XmAction<AdditionalDevicePayment>): AdditionalDevicePayment[] {
    let newState: AdditionalDevicePayment[];
    switch (action.type) {
        case StoreAction.SAVE_ADDITIONAL_DEVICE_PAYMENT_DATA:
        case StoreAction.GET_ADDITIONAL_DEVICE_PAYMENT:
            newState = state.filter((item: AdditionalDevicePayment) => item.deviceKey !== action.payload.deviceKey);

            return [ ...newState, action.payload ];
        case StoreAction.CLEAR_ADDITIONAL_DEVICE_PAYMENT:
            // if no filter then clear all
            if (!action.filters) {
                return undefined;
            }

            newState = state.filter((item: AdditionalDevicePayment) => item.deviceKey !== action.filters.deviceKey);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}

export function additionalDevicePaymentResultReducer(state: AdditionalDevicePaymentResult, action: XmAction<AdditionalDevicePaymentResult>): AdditionalDevicePaymentResult {
    switch (action.type) {
        case StoreAction.POST_ADDITIONAL_DEVICE_PAYMENT:
            return action.payload;
        default:
            return state;
    }
}
